import { useState } from 'react';
import { ISetTokenMessage, MessageTypes, IDirectLineToken } from '../core/Interfaces';
import useMessageListener from './useMessageListener';

export default function useSetTokenMessageListener() {
  const [token, setToken] = useState<IDirectLineToken | null>(null);

  useMessageListener<ISetTokenMessage>(MessageTypes.SetToken, (event) => {
    setToken(event.data.token);
  });

  return { token };
}
